import React from 'react';
import ArrowLeft from 'media/icons/arrow-empty-left.icon.svg';
import ArrowRight from 'media/icons/arrow-empty-right.icon.svg';

export const SliderArrow = ({ children, className, onClick }) => (
  <div onClick={onClick}>
    <button type="button" data-role="none" className={className}>
      {children}
    </button>
  </div>
);

export const getSettings = (arrowClassname) => {
  const arrowSetting = {
    prevArrow: (
      <SliderArrow>
        <span className={'screen-reader'}>Previous</span>
        <ArrowLeft className={arrowClassname} />
      </SliderArrow>
    ),
    nextArrow: (
      <SliderArrow>
        <span className={'screen-reader'}>Next</span>
        <ArrowRight className={arrowClassname} />
      </SliderArrow>
    ),
  };

  const sharedSettings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToScroll: 1,
  };

  return {
    responsive: [
      {
        breakpoint: 100000,
        settings: {
          slidesToShow: 4,
          ...sharedSettings,
          ...arrowSetting,
        },
      },
      {
        breakpoint: 1023,
        settings: {
          slidesToShow: 3,
          ...sharedSettings,
          ...arrowSetting,
        },
      },
      {
        breakpoint: 767,
        settings: {
          arrows: false,
          dots: true,
          infinite: true,
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
};



// WEBPACK FOOTER //
// ./src/utils/sliderSharedSettings.js